export const defaultEnAssetState = {
  urlEn: null,
  fileNameEn: null,
  descriptionEn: null,
};

export const defaultThAssetState = {
  urlTh: null,
  fileNameTh: null,
  descriptionTh: null,
};
